import { render, staticRenderFns } from "./BranchtoTellerSuper.vue?vue&type=template&id=56bba84e&scoped=true"
import script from "./BranchtoTellerSuper.vue?vue&type=script&lang=js"
export * from "./BranchtoTellerSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bba84e",
  null
  
)

export default component.exports